import { Paper } from '@trackman/web-shared-components';
import { TabList } from 'components/ui/TabList/TabList';
import { TabListItem, TabListWrapper } from 'components/ui/TabList/TabListStyles';
import React from 'react';
import styled from 'styled-components';
import { divider, tabsBorder } from 'styles/Colors';

export const TeamSetupPlaceholder = styled.div`
  &&& {
    background-color: #f5f5f5;
    height: 100%;
    min-height: 520px;
    padding: 0%;

    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

export const LoadingWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 13px;
  line-height: 12px;
  gap: 8px;
`;

export const PlaceholderText = styled.div`
  color: #717171;

  font-size: 15px;
  line-height: 21px;
`;

export const TeamSetupWrapper = styled(TabListWrapper)`
  ${TabListItem} {
    margin-bottom: 8px;
  }
  .card {
    height: 572px;
  }
`;
